<template>
  <div id="boothPayLog">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'boothPayLog'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/log/booth/BoothPayLog.vue